"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _getBoundingClientRect = require("./getBoundingClientRect");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _TabLine = _interopRequireDefault(require("./TabLine"));

var _TabListBase = _interopRequireDefault(require("./TabListBase"));

var _TabListDropdown = _interopRequireDefault(require("./TabListDropdown"));

require("../style/index.css");

var _class, _class2, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/tabs/index.css");

  require("../../spectrum-css/tabs/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/tabs/index-lg.css");
} else {
  require("../../spectrum-css/tabs/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/tabs/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/tabs/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/tabs/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/tabs/multiStops/darkest.css");
// For backward compatibility
var VARIANTS = {
  'panel': '',
  'anchored': '',
  'page': 'compact'
};
/**
 * A TabList displays a list of tabs
 */

var TabList = (0, _convertUnsafeMethod["default"])(_class = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TabList, _React$Component);

  function TabList(props) {
    var _this;

    _classCallCheck(this, TabList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedIndex: _TabListBase["default"].getDefaultSelectedIndex(_this.props),
      tabArray: [],
      tooNarrow: false
    });

    _this.debouncedResizeUpdate = null;
    return _this;
  }

  _createClass(TabList, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('selectedIndex' in nextProps) {
        this.setState({
          selectedIndex: nextProps.selectedIndex
        });
      }

      if (this.state.selectedIndex >= _react["default"].Children.toArray(nextProps.children).length) {
        this.onChange(_TabListBase["default"].getDefaultSelectedIndex(nextProps));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.resizeListener);
      this.updateTabs();
      this.widthCheck();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeListener);
      this.clearDebouncedResizeUpdateInterval();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        this.updateTabs();
        this.widthCheck();
      }
    }
  }, {
    key: "resizeListener",
    value: function resizeListener() {
      var _this2 = this;

      if (!this.debouncedResizeUpdate) {
        this.debouncedResizeUpdate = setTimeout(function () {
          _this2.widthCheck();

          _this2.debouncedResizeUpdate = null;
        }, 50);
      }
    }
  }, {
    key: "clearDebouncedResizeUpdateInterval",
    value: function clearDebouncedResizeUpdateInterval() {
      if (this.debouncedResizeUpdate) {
        clearTimeout(this.debouncedResizeUpdate);
        this.debouncedResizeUpdate = null;
      }
    } // will need to change to left probably if dealing with rtl

  }, {
    key: "getFurthestPoint",
    value: function getFurthestPoint(elem) {
      return (0, _getBoundingClientRect.getBoundingClientRect)(elem).right;
    }
  }, {
    key: "widthCheck",
    value: function widthCheck() {
      var tabList = _reactDom["default"].findDOMNode(this); // since tab array is in state, we don't necessarily have the most recent if we just use
      // state.tabArray, so get the tabs for the width check


      var tabs = _reactDom["default"].findDOMNode(this).querySelectorAll('.spectrum-Tabs-item');

      var farEdgeTabList = this.getFurthestPoint(tabList);
      var farEdgeLastTab = this.getFurthestPoint(tabs[tabs.length - 1]);

      if (farEdgeTabList < farEdgeLastTab) {
        this.setState({
          tooNarrow: true
        });
      } else {
        this.setState({
          tooNarrow: false
        });
      }
    }
  }, {
    key: "updateTabs",
    value: function updateTabs() {
      // Measure the tabs so we can position the line below correctly
      var tabArray = _reactDom["default"].findDOMNode(this).querySelectorAll('.spectrum-Tabs-item');

      this.setState({
        tabArray: tabArray
      });
    }
  }, {
    key: "onChange",
    value: function onChange(selectedIndex) {
      var lastSelectedIndex = this.state.selectedIndex; // If selectedIndex is defined on props then this is a controlled component and we shouldn't
      // change our own state.

      if (!('selectedIndex' in this.props)) {
        this.setState({
          selectedIndex: selectedIndex
        });
      }

      if (lastSelectedIndex !== selectedIndex && this.props.onChange) {
        this.props.onChange(selectedIndex);
      }
    }
  }, {
    key: "getTabList",
    value: function getTabList() {
      var _classNames;

      var _this$props = this.props,
          className = _this$props.className,
          _this$props$orientati = _this$props.orientation,
          orientation = _this$props$orientati === void 0 ? 'horizontal' : _this$props$orientati,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? '' : _this$props$variant,
          quiet = _this$props.quiet,
          children = _this$props.children,
          defaultSelectedIndex = _this$props.defaultSelectedIndex,
          collapsible = _this$props.collapsible,
          otherProps = _objectWithoutProperties(_this$props, ["className", "orientation", "variant", "quiet", "children", "defaultSelectedIndex", "collapsible"]);

      var _this$state = this.state,
          selectedIndex = _this$state.selectedIndex,
          tabArray = _this$state.tabArray,
          tooNarrow = _this$state.tooNarrow;
      var selectedTab = tabArray[selectedIndex]; // For backwards compatibility
      // let mappedVariant = VARIANTS[variant] !== undefined ? VARIANTS[variant] : variant;

      if (VARIANTS[variant] != null) {
        var message = "The \"".concat(variant, "\" variant of TabList has been deprecated.");

        if (VARIANTS[variant]) {
          message += " Please use the \"".concat(VARIANTS[variant], "\" variant instead.");
        } else {
          message += ' Please remove the variant prop to use the default variant instead.';
        }

        console.warn(message);
        variant = VARIANTS[variant];
      }

      var tooNarrowProps = {};
      var shouldHide = false;

      if (collapsible && tooNarrow && orientation !== 'vertical') {
        tooNarrowProps['aria-hidden'] = tooNarrow;
        shouldHide = true;
      }

      return _react["default"].createElement(_TabListBase["default"], _extends({}, tooNarrowProps, {
        orientation: orientation,
        defaultSelectedIndex: defaultSelectedIndex || null,
        selectedIndex: selectedIndex
      }, otherProps, {
        className: (0, _classnames["default"])('spectrum-Tabs', "spectrum-Tabs--".concat(orientation), (_classNames = {
          'spectrum-Tabs--quiet': quiet
        }, _defineProperty(_classNames, "spectrum-Tabs--".concat(variant), variant), _defineProperty(_classNames, 'react-spectrum-Tabs--container', collapsible), _defineProperty(_classNames, 'react-spectrum-Tabs--hidden', shouldHide), _classNames), className),
        onChange: this.onChange
      }), children, selectedTab && _react["default"].createElement(_TabLine["default"], {
        orientation: orientation,
        selectedTab: selectedTab
      }));
    }
  }, {
    key: "getDropdown",
    value: function getDropdown() {
      var _this$props2 = this.props,
          quiet = _this$props2.quiet,
          children = _this$props2.children,
          ariaLabelledby = _this$props2['aria-labelledby'],
          ariaLabel = _this$props2['aria-label'];
      var selectedIndex = this.state.selectedIndex;
      return _react["default"].createElement(_TabListDropdown["default"], {
        className: (0, _classnames["default"])({
          'spectrum-Tabs--quiet': quiet
        }),
        selectedIndex: selectedIndex,
        onChange: this.onChange,
        quiet: quiet,
        "aria-labelledby": ariaLabelledby,
        "aria-label": ariaLabel
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          collapsible = _this$props3.collapsible,
          orientation = _this$props3.orientation;
      var tooNarrow = this.state.tooNarrow;

      if (collapsible && orientation !== 'vertical') {
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])('react-spectrum-Tabs--collapsible')
        }, this.getTabList(), tooNarrow && this.getDropdown());
      } else {
        return this.getTabList();
      }
    }
  }]);

  return TabList;
}(_react["default"].Component), _defineProperty(_class2, "propTypes", {
  /** The visual style of the tab list */
  variant: _propTypes["default"].oneOf(['compact', 'panel', 'anchored', '']),

  /** Whether the tab list should render using a quiet style */
  quiet: _propTypes["default"].bool,

  /** The layout orientation of the tabs */
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /**
   * Whether selection should be 'automatic' when a Tab receives keyboard focus
   * or 'manual' using Enter or Space key to select.
   */
  keyboardActivation: _propTypes["default"].oneOf(['automatic', 'manual']),

  /**
   * The index of the Tab that should be selected (open). When selectedIndex is
   * specified, the component is in a controlled state and a Tab can only be selected by changing the
   * selectedIndex prop value. By default, the first Tab will be selected.
   */
  selectedIndex: _propTypes["default"].number,

  /**
   * The same as selectedIndex except that the component is in an uncontrolled
   * state.
   */
  defaultSelectedIndex: _propTypes["default"].number,

  /**
   * A function that will be called when an Tab is selected or deselected. It will be passed
   * the updated selected index.
   */
  onChange: _propTypes["default"].func,

  /**
   * If the parent is display flex or an explicit width is given to this component, then it can be
   * collapsible and you may set this to true.
   */
  collapsible: _propTypes["default"].bool,

  /**
   * Whether to autoFocus first selected Tab or first Tab.
   */
  autoFocus: _propTypes["default"].bool
}), _defineProperty(_class2, "defaultProps", {
  variant: '',
  quiet: false,
  orientation: 'horizontal',
  collapsible: false,
  autoFocus: false
}), _temp)) || _class) || _class;

exports["default"] = TabList;